






















































































import Vue from 'vue'
import PageDefaultLayout from '@/components/globals/PageDefaultLayout.vue'
import SearchHistoryList from '@/components/modal/SearchFacilityModal/SearchHistoryList.vue'
import { Meta } from '@/tools/page'
import {
  getSearchHistories,
  AreasByPref,
  Area,
  SearchHistory,
  SearchParams,
  queryToSearchHistory,
  useFacilitiesMetadataStore,
  conditionsToPath,
} from '@/core/Facilities'
import { Activity } from '@/core/Activities'

const PAGE_TITLE = '検索MENU'
const PAGE_META: Meta[] = [
  {
    name: 'description',
    content:
      '1チケットフィットネスサービスGYYM(ジーム)の会員登録画面です。GYYMに登録すると、入会金なしで今話題のフィットネスや人気のプログラムを受講することができます。',
  },
]

const facilitiesMetadataStore = useFacilitiesMetadataStore()

export default Vue.extend({
  components: {
    PageDefaultLayout,
    SearchHistoryList,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    activities(): Activity[] {
      return facilitiesMetadataStore.getActivities()
    },
    areasByPref(): AreasByPref[] {
      return facilitiesMetadataStore.getAreasByPref()
    },
    areas(): Area[] {
      return facilitiesMetadataStore.getAreas()
    },
    facilitySearchValues(): SearchParams {
      return queryToSearchHistory({})
    },
    facilitySearchHistories(): SearchHistory[] {
      return getSearchHistories()
    },
  },
  async created() {
    this.$setPageTitle(PAGE_TITLE)
    this.$setPageMeta(PAGE_META)
    this.isLoading = true

    const searchType = this.$route.query.type
    if (searchType) {
      switch (searchType) {
        case 'area':
          this.$modal.push('app/AreaByPrefectureModal')
          break
        case 'name':
          this.$modal.push('app/SearchByNameModal')
          break
        case 'condition':
        default:
          this.$modal.push('app/SearchFacilityDetailModal')
          break
      }
    }

    await this.fetchData()

    this.isLoading = false
  },
  methods: {
    async fetchData() {
      await facilitiesMetadataStore.fetch()
    },
    onSearchByHistory(history: SearchHistory) {
      // 検索結果に遷移
      this.$router
        .push(
          conditionsToPath(
            Object.keys(history).reduce(
              (acc, key) =>
                (history as any)[key]
                  ? { ...acc, [key]: (history as any)[key] }
                  : acc,
              {}
            ),
            this.areasByPref
          )
        )
        .catch(() => {})
    },
  },
})
